var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00002 16.8996C4.39752 16.8996 0.666687 13.1687 0.666687 8.56624C0.666687 3.96374 4.39752 0.23291 9.00002 0.23291C13.6025 0.23291 17.3334 3.96374 17.3334 8.56624C17.3334 13.1687 13.6025 16.8996 9.00002 16.8996ZM9.00002 15.2329C10.7681 15.2329 12.4638 14.5305 13.7141 13.2803C14.9643 12.03 15.6667 10.3344 15.6667 8.56624C15.6667 6.79813 14.9643 5.10244 13.7141 3.8522C12.4638 2.60196 10.7681 1.89958 9.00002 1.89958C7.23191 1.89958 5.53622 2.60196 4.28598 3.8522C3.03573 5.10244 2.33335 6.79813 2.33335 8.56624C2.33335 10.3344 3.03573 12.03 4.28598 13.2803C5.53622 14.5305 7.23191 15.2329 9.00002 15.2329ZM9.83335 8.56624H13.1667V10.2329H8.16669V4.39958H9.83335V8.56624Z",
    fill: "#190DA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.5f34ab9d90eb4a245287c58bc08eae92.svg";
export { ForwardRef as ReactComponent };